/** Empty Cash Report copy. Pending compute ≠ missing cash-on-hand. */

export function cashEmptyHeadline({ hasVersion, pending }) {
  if (hasVersion) return null
  if (pending) return 'Computing your first forecast…'
  return 'Not enough inputs yet'
}

export function cashEmptyShowSkeleton({ hasVersion, pending }) {
  return !hasVersion && !!pending
}

export function cashEmptyShowConfirmBank({ hasVersion, pending }) {
  return !hasVersion && !pending
}
